<template>
  <el-row>

    <el-col :span="24">
      <el-col :span="24">
        <el-form  :inline="true"  :model="where"    class="demo-form-inline searchbox">
                  <el-form-item label="关键词：">
                    <el-input @keyup.native.enter="getuserlist" v-model="keyword" prefix-icon="el-icon-search" placeholder="请输入检索内容等查询..."></el-input> 
                  </el-form-item>
                   
                   
                   <el-form-item >
                  <el-button
            style="margin-left:10px;"
            icon="el-icon-search"
            type="success"
            @click="getuserlist"
          >快速查询</el-button>
          <el-button
            style="margin-left:10px;"
            icon="el-icon-plus"
            type="primary"
            @click="adduser"
          >新增用户</el-button>
                  </el-form-item>
                  </el-form>
         
      </el-col>
      <el-col
        :span="24"
        style="background:rgba(0,217,255,.15);padding:10px; "
      >
        <el-row>

          <el-col :span="24">

            <el-table
              :data="userlist"
              style="width: 100%"
              border
                v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
            >
            <el-table-column
                   
                    type="index"
                     align="center"
                      label="序号"
                    width="50">
                  </el-table-column>
              <el-table-column
                
                prop="loginname"
                label="登录名"
                min-width="120"
              >
              </el-table-column>
              <el-table-column
               
                prop="username"
                label="姓名"
                align="center"
                min-width="100"
              >
              </el-table-column>
               
              <el-table-column
                prop="role"
                label="所属角色"
                min-width="100"
              >
              </el-table-column>
               
              <el-table-column
                prop="createtime"
                align="center"
                label="创建日期"
                min-width="150"
              >
              </el-table-column>
              <el-table-column
                prop="lastlogintime"
                label="最后登录时间"
                align="center"
                min-width="120"
              >
              </el-table-column>
              <el-table-column
                prop="lastloginip"
                align="center"
                label="最后登录IP"
                min-width="120"
              >
              </el-table-column>

              <el-table-column
                prop="caozuo"
                label="操作"
                align="center"
                width="250"
              >
               <template slot-scope="scope">
                  <el-button
                    @click="edituserbtn(scope.row)"
                    type="warning"
                    size="small"
                  >编辑</el-button>
                  <el-button
                    @click="deluserbtn(scope.row)"
                    type="danger"
                    size="small"
                  >删除</el-button>
                  <el-button
                    @click="chongzhimmbtn(scope.row)"
                    type="success"
                    size="small"
                  >重置密码</el-button>
                </template>
              </el-table-column>
            </el-table>

          </el-col>
           <!-- <el-col style="margin-top:10px;text-align:center;">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="10">
                </el-pagination>
              </el-col> -->
          
        </el-row>

      </el-col>
    </el-col>
    <el-dialog
      title=""
      :visible.sync="dialogEditUserVisible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :show-close="false"
    >
      <el-row style="    margin-top: -40px;">
        <el-col
          :span="24"
          class="stoptitle"
        >
          新增用户
        </el-col>
        <el-col
          :span="24"
          style="margin-top:10px"
        >
          <el-form
            :model="editUserModel"
            :rules="userRules"
            ref="userForm"
            label-width="100px"
          >
            <el-form-item
              label="登录名称"
              prop="loginname"
            >
              <el-input v-model="editUserModel.loginname" :disabled="edituser"></el-input>
            </el-form-item>
            <el-form-item
              label="用户名"
              prop="username"
            >
              <el-input v-model="editUserModel.username"></el-input>
            </el-form-item>
            
            <el-form-item
              label="用户角色"
              prop="role"
            >
              <el-select
                v-model="editUserModel.role"
                placeholder="请选择用户角色"
              >
                <el-option v-for="(item,index) in rolelist" :key="index"
                  :label="item.juesemc"
                  :value="item.id"
                ></el-option>
                
              </el-select>
            </el-form-item>

          </el-form>
        </el-col>
      </el-row>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogEditUserVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('userForm')"
        >确 定</el-button>
      </span>
    </el-dialog>

  </el-row>
</template>
<script>

import { getallrole,getalluser,edituser,deluser,chongzhimm} from "../../api/api";

export default {
  data() {
    return {
      loading:false,
      keyword: "",
      userlist: [],
      dialogEditUserVisible: false,
      editUserModel: {
        loginname: "",
        username: "",
        role: ""
      },
      userRules: {
        loginname: [
          { required: true, message: "请输入登录名", trigger: "blur" },
          { min: 3, max: 18, message: "长度在 3 到 18 个字符", trigger: "blur" }
        ],
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          { min: 1, max: 10, message: "长度在 1 到 10 个字符", trigger: "blur" }
        ],
       
        role: [{ required: true, message: "请选择用户角色", trigger: "change" }]
      },
      rolelist:[],
      edituser:false,
    };
  },
  created(){
    let that = this;
    getallrole({}).then(res=> {
      that.rolelist = res.data
    });
    that.getuserlist();
  },
  methods: {
    chongzhimmbtn(row){
      let that = this;
this.$confirm("确认要将此用户密码重置为123456吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          chongzhimm({ id: row.id }).then(res => {
            if (res.code == 0) {
              this.$message({
                message: "密码重置成功",
                type: "success"
              });
              that.getalluser();
            } else {
              this.$message({
                message: res.msg,
                type: "error"
              });
            }
          });
         
        })
        .catch(() => {});
    },
    edituserbtn(row) {
      this.editUserModel.id = row.id;
      this.editUserModel.loginname = row.loginname;
      this.editUserModel.username = row.username;
    
      this.editUserModel.role = row.roleid
      this.edituser = true;
      this.dialogEditUserVisible = true;
    },

    deluserbtn(row) {
       let that = this;
      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deluser({ id: row.id }).then(res => {
            if (res.code == 0) {
              this.$message({
                message: "删除用户成功",
                type: "success"
              });
              that.getuserlist();
            } else {
              this.$message({
                message: res.msg,
                type: "error"
              });
            }
          });
        
        })
        .catch(() => {});
    },
    adduser() {
      this.editUserModel.loginname = "";
      this.editUserModel.username = "";
     
      this.editUserModel.role = "";
      this.edituser = false;
      this.dialogEditUserVisible = true;
    },
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          edituser({
            id: that.editUserModel.id,
            LoginName: that.editUserModel.loginname,
            UserName: that.editUserModel.username,
            
            RoleId: that.editUserModel.role,
          }).then(res => {
            if (res.code == 0) {
              this.$message({
                message: "编辑用户成功",
                type: "success"
              });
              that.dialogEditUserVisible = false;
              that.getuserlist();
            } else {
              this.$message({
                message: res.msg,
                type: "error"
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getuserlist (){
      let that = this;
      that.loading = true;
      getalluser({keyword:this.keyword}).then(res =>{
        that.userlist = res.data;
        setTimeout(() =>{
          that.loading = false;
        },200)
      })
    }
  }
};
</script>